import Column from '@components/Column';
import Description from '@components/Description';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';

import useAssets from './hooks/useAssets';

function DisposeDescription() {
  const { data } = useAssets();
  const project = useProject();

  return (
        <Description>
            <Column fullWidth spacing={6}>
                {project?.features.ppCardEnabled && (
                    <DisposeRow label='선불카드 잔액'
                                value={`${data?.prepaidCardBalance?.toLocaleString() || 0}원`} />
                )}
                {data?.rewardType === 'STAMP' && (
                    <DisposeRow label='스탬프'
                                value={`${data?.stampCount?.toLocaleString() || 0}개`} />
                )}
                {data?.rewardType === 'POINT' && (
                    <DisposeRow label='포인트'
                                value={`${data?.points?.toLocaleString() || 0}원`} />
                )}
                <DisposeRow label='쿠폰'
                            value={`${data?.couponCount?.toLocaleString() || 0}개`} />
            </Column>
        </Description>
  );
}

interface RowProps {
    label: string;
    value: string;
}

function DisposeRow({ label, value }:RowProps) {
  return (
        <Row fullWidth
             justify='space-between' >
            <Text color={colors.gray6}>{label}</Text>
            <Text
                  color={colors.gray7}
                  fontWeight='bold' >
                {value}
            </Text>
        </Row>
  );
}

export default DisposeDescription;
